import { BaseModel, attr } from "../../lib/itn-ui-kit/data";

export default class PreSignedUrlModel extends BaseModel {
  @attr("string") url;
}
